import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { Button } from 'components/common';
import { Box } from 'components/common/box';
import { Form, FormSection } from 'components/common/form';
import { SupervisorSummaryEmailSettings } from '.';

import type { PageState } from 'types';

const MyTeamSettings = () => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { supervisor },
    serverConfig,
    user
  } = useReduxState();

  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async (values: typeof initialValues) => {
    try {
      setIsSaving(true);

      await api.put(`/admin/supervisors/${user.id}`, {
        settings: { ...values }
      });
      dispatch(
        actions.updatePageState({
          supervisor: { ...supervisor, ...values } as PageState['supervisor']
        })
      );
      dispatch(
        actions.addNotice({
          text: messages.settingsSavedSuccessfully,
          type: 'success'
        })
      );
      setIsSaving(false);
    } catch (err) {
      setIsSaving(false);
      await dispatch.handleErrorDispatch(err);
    }
  };

  const initialValues = {
    enableSummaryEmail: serverConfig.supervisorSummaryEmailEnabled
      ? true
      : supervisor?.enableSummaryEmail,
    summaryEmailFrequency: serverConfig.supervisorSummaryEmailEnabled
      ? serverConfig.supervisorSummaryEmailFrequency
      : supervisor?.summaryEmailFrequency,
    summaryEmailOptions: serverConfig.supervisorSummaryEmailEnabled
      ? {
          ...supervisor?.summaryEmailOptions,
          ...Object.keys(
            serverConfig.supervisorSummaryEmailOptions || {}
          ).reduce((options, option) => {
            if (serverConfig.supervisorSummaryEmailOptions[option]) {
              options[option] = true;
            }
            return options;
          }, {})
        }
      : supervisor?.summaryEmailOptions
  };

  return (
    <Box padding={0} title={messages.commonSettings}>
      <Form initialValues={initialValues} onSubmit={handleSubmit}>
        {({ formState }) => (
          <>
            <SupervisorSummaryEmailSettings isSiteSettingsView={false} />

            <FormSection>
              <Button
                category="success"
                disabled={formState.pristine}
                loading={isSaving}
                text={messages.commonSave}
                type="submit"
              />
            </FormSection>
          </>
        )}
      </Form>
    </Box>
  );
};

export default MyTeamSettings;
